const menus = [
    {
        id: 1,
        name: 'Home',
        links: '/',
         
    },
    {
        id: 2,
        name: 'Explore',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'Market info',
                links: '/market-info'
            },
            {
                id: 2,
                sub: 'Things we trade',
                links: '/things-we-trade'
            },
            {
                id: 3,
                sub: 'Market spread and swaps',
                links: '/market-spread'
            },
            {
                id: 4,
                sub: 'Visions & Mission',
                links: '/visions-mission'
            },
            {
                id: 5,
                sub: 'Terms and Condition',
                links: '/terms'
            },
            {
                id: 6,
                sub: 'Privacy policy',
                links: '/privacy-policy'
            },
            {
                id: 7,
                sub: 'Disclaimer',
                links: '/disclaimer'
            },
            {
                id: 8,
                sub: 'Refund policy',
                links: '/refund-policy'
            },
        ]
    },
    {
        id: 4,
        name: 'About',
        links: '/about',
        
    },
    {
        id: 5,
        name: 'Services',
        links: '/Services',
        
    },
    {
        id: 6,
        name: 'Pricing',
        links: '/Pricing',
        
    },
    {
        id: 7,
        name: 'Contact',
        links: '/contact',
    },

    
]

export default menus;